import React, { memo } from 'react'
import { Grid, makeStyles } from 'transfix-ui/core'
import { IVersion } from 'types/logs'
import { LaneArrowIcon } from 'transfix-icons'
import { formatVersionChanges } from 'utils/versionHelpers'

interface IChangeEventsProps {
  version: IVersion
  condensed: boolean
}

const useChangeEventsStyles = makeStyles(theme => ({
  container: {
    padding: 0,
    marginBottom: theme.spacing(1),
  },
  beforeCell: {
    textAlign: 'right',
  },
  arrowCell: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export const ChangeEvents = memo<IChangeEventsProps>(({ condensed, version }) => {
  const classes = useChangeEventsStyles()
  return (
    <>
      {formatVersionChanges(version).map(({ after, before, key, label }) => (
        <Grid container key={key} className={classes.container}>
          <Grid item xs={condensed ? 2 : undefined} md={2}>
            <strong>{label}</strong>
          </Grid>
          <Grid item xs={condensed ? 4 : undefined} md={4} className={classes.beforeCell}>
            {before}
          </Grid>
          <Grid item xs={condensed ? 2 : undefined} md={2} lg={1} className={classes.arrowCell}>
            <LaneArrowIcon />
          </Grid>
          <Grid item xs={condensed ? 4 : undefined} md={4}>
            {after}
          </Grid>
        </Grid>
      ))}
    </>
  )
})
